/** 
 * Vuex.Store getters
 * @author LiQingSong
 */
const getters = {
  siteFiexdHeader: state => state.app.siteFiexdHeader,
  siteTopNavEnable: state => state.app.siteTopNavEnable,
  siteSidebarLogo: state => state.app.siteSidebarLogo,
  sidebarOpened: state => state.app.sidebarOpened,
  token: state => state.user.token,
  region: state => state.user.region,
  msgtotal: state => state.user.msgtotal,
  name: state => state.user.name,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes
};
export default getters;
